import Vue from 'vue';
import App from './App.vue';

// SCSS
import '../scss/app.scss';

// Store & Router
import router from './models/router.js';
import store from './models/stores.js';

import Meta from 'vue-meta';
Vue.use(Meta);

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-150992371-2',
  router
});

import device from "vue-device-detector";
Vue.use(device);

//import lax from 'lax.js';
import anime from 'animejs/lib/anime.es';

//With router
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    //lax.setup();

    var last_scrollY = 0;
    document.addEventListener('scroll', function(e) {
      //lax.update(window.scrollY);
      var delta_scrollY = window.scrollY - last_scrollY;
      last_scrollY = window.scrollY;

      anime({
        targets: [ '#leaves_sides > div.left', '#leaves_sides > div.right' ],
        backgroundPositionY: '-=' + (delta_scrollY * 0.5) + 'px',
        duration: 0,
        easing: 'linear'
      });
    }, false);
  }
}).$mount('#app');